import axios from 'axios';
import { TIMEOUT_SECS } from '../constants';

axios.defaults.timeout = TIMEOUT_SECS * 1000;
axios.defaults.responseType = 'json';

export default axios;
